



























// TODO: convert to TS class
import Vue from 'vue';
import ElementQueries from 'css-element-queries';

export default Vue.extend(
{
    data()
    {
        return {
			resizeSensor: <ElementQueries.ResizeSensor><any>null,
            notes : '',
			bHidden : true,
			lastHidden : new Date("1/1/1970"),
        };
	},
	computed: {
		hidden: {
			get()
			{
				return (this as any).bHidden;
			},

			set(value)
			{
				(this as any).bHidden = value;
				(this as any).lastHidden = new Date();
				setTimeout(() => {
					// Check in case the component is unmounted during the timeout
					if ((this as any).hide_content)
					{
						this.$recompute("hide_content");
					}
					
					this.$nextTick(()=>{
						if(this.bHidden)
						{
							//(document.activeElement as HTMLElement).blur();
							(this.$refs.escapeFocusElement as HTMLElement).focus();	//it's hacky but for some reason blurring the focus on the close button wasn't working
						} 
						else
						{
							(this.$refs.textArea as HTMLElement).focus();				
						}
					})
				}, 550);
			}
		}
	},
	recomputed: {
		widthOffset()
		{
			let width = window.innerWidth;
			if (width * 0.2 < 350)
				return '-350px';
			return '-20vw';
		},

		hide_content()
		{
			let _this = this as any;
			return _this.bHidden && (new Date().getTime() - _this.lastHidden.getTime()) > 0.5;
		}
	},
    mounted()
    {
        if (localStorage.notes != null)
        {
            this.notes = localStorage.notes;
		}
		
		this.$nextTick(()=>{
			this.resizeSensor = new ElementQueries.ResizeSensor(this.$refs.notepad, ()=>{
				this.$nextTick(()=>{
					this.$recompute('widthOffset')
				})
			})
		})
    },
    watch:
    {
        notes(newNotes)
        {
            localStorage.notes = newNotes;
        }
    },
    methods:
    {
        show()
        {
            this.hidden = false;
		}
    }
})
